import React from 'react'
import './PokerTable.scss'
import { useSelector } from 'react-redux'

export function Chip({ coordinates, dealerPos, index = 0 }) {
	const { players, isLoadingData } = useSelector((state) => state.trainer.tables[index])
	const dealerPosition =
		dealerPos ||
		(!isLoadingData && players && Object.entries(players).find(([_, player]) => !isLoadingData && player.isDealer)?.[0])

	return (
		<>
			{!isLoadingData && dealerPosition && (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					x={coordinates && coordinates[dealerPosition]?.chip?.x}
					y={coordinates && coordinates[dealerPosition]?.chip?.y}
					width={10}
					height={20}
					viewBox='0 0 41.06 40.75'
					xmlSpace='preserve'
				>
					<style>{`.ch0{fill:#EFB930;}.ch1{fill:#15171F;`} </style>
					<g>
						{/*<circle className='ch0' cx='20.32' cy='20.73' r='25.54' />*/}
						<circle className='ch0' cx='20.5' cy='20.5' r='20.5' />
						<g>
							<path
								className='ch1'
								d='M26.46,13.17c1.81,1.36,2.71,3.86,2.71,7.49c0,3.56-0.89,6.07-2.66,7.52c-1.77,1.46-4.04,
							2.18-6.8,2.18h-5.51V11.13h5.03C22.24,11.13,24.65,11.81,26.46,13.17z M18.29,
							14.13v13.24h1.67c1.58,0,2.79-0.49,3.66-1.46c0.86-0.97,1.29-2.72,
							1.29-5.24c0-1.74-0.22-3.1-0.65-4.06c-0.44-0.96-1.01-1.62-1.74-1.96c-0.72-0.34-1.6-0.51-2.64
							-0.51H18.29z'
							/>
						</g>
					</g>
				</svg>
			)}
		</>
	)
}
